import { ConfidentialityDecision } from 'types/caseClosing';
import { MatterForm } from 'types/matters';
import { isMatterClosed } from 'utils/matterState';
import { requiresStillConfidentialConfirmation } from './confidentialityRules';

export function isConfidentialReasonFieldShown(isConfidential: boolean, matterStateTypeCode?: string | null): boolean {
    return isConfidential && isMatterClosed(matterStateTypeCode);
}

/** Required only while the save closes the case; an already closed case is edited without one. */
export function isConfidentialReasonFieldRequired(
    isConfidential: boolean,
    matterStateTypeCode: string | null | undefined,
    savedMatterStateTypeCode: string | null | undefined,
    isReasonRequiredOnClose: boolean
): boolean {
    return (
        isConfidentialReasonFieldShown(isConfidential, matterStateTypeCode) &&
        !isMatterClosed(savedMatterStateTypeCode) &&
        isReasonRequiredOnClose
    );
}

/** Saving the edit form with "Is confidential" still ticked is the decision to keep the case confidential. */
export function requiresStillConfidentialConfirmationOnSave(
    form: Pick<MatterForm, 'isConfidential' | 'matterStateType' | 'confidentialReason'>,
    savedMatterStateTypeCode: string | null | undefined
): boolean {
    const isClosing = isMatterClosed(form.matterStateType?.value) && !isMatterClosed(savedMatterStateTypeCode);
    return (
        isClosing &&
        requiresStillConfidentialConfirmation(
            form.isConfidential,
            ConfidentialityDecision.KEEP,
            form.confidentialReason ?? ''
        )
    );
}
